// export  const ENDPOINT = "http://localhost:5000";
export  const ENDPOINT = "https://chatapp-api-server.onrender.com";
// export  const ENDPOINT = "https://chatapp-api-production.up.railway.app";
